import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Patente() {
  const { t } = useLanguage();

  return (
    <section className="bg-cream-dark/50 py-20 md:py-28" data-testid="patente-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="patente-kicker">{t.patente.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.patente.title}
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-forest-800/80">{t.patente.lead}</p>
        </Reveal>

        <Reveal className="mt-12">
          <div className="card-lift border border-forest-800/40 bg-white p-8 md:p-12" data-testid="patente-card">
            <p className="font-body text-[11px] font-bold uppercase tracking-[0.3em] text-forest-700">
              {t.patente.cardKicker}
            </p>
            <p className="mt-4 font-display text-4xl font-bold tracking-tight text-forest-800 md:text-6xl" data-testid="patente-number">
              {t.patente.number}
            </p>
            <p className="mt-3 font-display text-lg italic text-forest-800/75 md:text-xl">{t.patente.name}</p>

            <div className="mt-8 grid gap-6 border-t border-forest-800/20 pt-6 sm:grid-cols-3">
              {t.patente.meta.map((meta) => (
                <div key={meta.l}>
                  <p className="font-body text-[10px] font-bold uppercase tracking-[0.25em] text-forest-800/50">
                    {meta.l}
                  </p>
                  <p className="mt-2 text-sm font-bold text-forest-800">{meta.v}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-8 md:grid-cols-3">
          {t.patente.feats.map((feat, index) => (
            <Reveal key={feat.t} delay={index * 0.1}>
              <div className="rule pt-5">
                <h4 className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-ember">{feat.t}</h4>
                <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{feat.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10">
          <p className="max-w-4xl text-xs italic leading-relaxed text-forest-800/60" data-testid="patente-footnote">
            {t.patente.footnote}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
